/* Newsletter forms (footer, welcome card) send in the background so the page does not reload and jump to the top.
   If Shopify answers with a challenge page (bot check) or the request fails, the form falls back to a normal submit. */
(function () {
  if (window.smSignup) return; window.smSignup = true;
  function say(form, text, ok) {
    var m = form.parentNode.querySelector('[data-sm-signup-msg]');
    if (!m) { m = document.createElement('p'); m.setAttribute('data-sm-signup-msg', ''); m.className = 'sm-signup-msg'; form.insertAdjacentElement('afterend', m); }
    m.setAttribute('role', ok ? 'status' : 'alert'); m.textContent = text;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-sm-signup]') || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]'); if (btn) btn.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .then(function (r) {
        /* Shopify redirects to ?customer_posted=true after a successful sign-up; a bot check sends to /challenge. */
        if (/\/challenge/.test(r.url)) { form.removeAttribute('data-sm-signup'); form.submit(); return; }
        if (/customer_posted=true/.test(r.url)) { form.reset(); say(form, 'Thank you. You are on the list.', true); return; }
        say(form, 'Please check your email address and try again.', false); if (btn) btn.disabled = false;
      })
      .catch(function () { form.removeAttribute('data-sm-signup'); form.submit(); });
  });
})();
